import * as React from 'react';
import styled from 'styled-components';
import { intlShape } from 'react-intl';

export interface Props {}

const Wrapper = styled.header`
  font-size: 14px;
  min-height: 50px;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  color: #fff;
  background-color: #333;
  box-shadow: 1px 1px 1px 0 rgba(0,0,0,.1);
`;

const HeaderTitle = styled.p`
  margin-left: 14px;
  margin-top: 17px;
`;

class Header extends React.Component<Props, null> {
  static get contextTypes() {
    return { intl: intlShape };
  }
  render() {
    const { formatMessage } = this.context.intl;
    return (
        <Wrapper>
          <HeaderTitle>
            {formatMessage({id: 'title'})}
          </HeaderTitle>
        </Wrapper>
    );
  }
};

export default Header;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/Header.tsx